import React, { Fragment } from "react"
import { GraphQLClient } from 'graphql-request'
import { endpoint, endpointold } from './queries/endpoint'



export default class Transferdb extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            token: JSON.parse(sessionStorage.getItem('OITO')).token,
            log: []
        }

        this.clientold = new GraphQLClient(endpointold)
        this.clientauth = new GraphQLClient(endpoint, {
            headers: {
                Authorization: `Bearer ${this.state.token}`,
            },
        })

        this.client = new GraphQLClient(endpoint)
    }



    async categories() {
        console.log('categoria')

        await this.clientold.request(`
        query{
            allCategories{
                description
                file {
                    url
                }      
                name        
            }
        }`).then(
            res => {
                console.log(res)

                if (res) {
                    res.allCategories.map(async i =>
                        await this.clientauth.request(`
                mutation {
                    createCategory(input:{
                        name: "${i.name}"
                        description: "${i.description}"
                        file: "${i.file.url}"
                    }){
                        id
                        name
                    }
                }`).then(
                            res => {
                                console.log(res)
                                if (res.createCategory) {
                                    const newlog = [
                                        ...new Set([...this.state.log, `Cateogria: ${res.createCategory.name}`])
                                    ]
                                    this.setState({ log: newlog })
                                }
                            }))
                }
            })
    }

    async habilidades() {
        console.log('habilidade')

        await this.clientold.request(`
        query{
            allSkillses{
                category {
                    name
                }
                name       
            }
        }`).then(
            res => {
                console.log(res)

                if (res.allSkillses) {
                    res.allSkillses.map(async i =>
                        await this.client.request(`
                        {
                            allCategories(filter:{
                                name: "${i.category.name}"
                            }){
                                id
                            }
                        }`).then(
                            async res => {
                                console.log(res.allCategories[0].id)
                                console.log(i)
                                if (res.allCategories) {
                                    await this.clientauth.request(`
                                        mutation {
                                            createSkills(input:{
                                                categoryId: "${res.allCategories[0].id}"
                                                name: "${i.name}"
                                            }){
                                                id
                                                name
                                            }
                                        }`).then(
                                        res => {
                                            console.log(res)
                                            if (res.createSkills) {
                                                const newlog = [
                                                    ...new Set([...this.state.log, `Skill: ${res.createSkills.name}`])
                                                ]
                                                this.setState({ log: newlog })
                                            }
                                        })
                                }
                            })
                    )
                }
            })
    }

    async posts() {
        console.log('posts')

        await this.clientold.request(`
        query{
            allPosts{
                content
                published
                thumbnail {
                    url
                }
                title
                updated      
            }
        }`).then(
            res => {
                console.log(res)

                if (res) {
                    res.allPosts.map(async i =>
                        await this.clientauth.request(`
                mutation {
                    createPost(input:{
                        content: "${i.content.toString()}"
                        published: ${i.published}
                        thumbnail: "${i.thumbnail.url}"
                        title: "${i.title}"
                        updated: "${i.updated}"
                    }){
                        id
                        title
                    }
                }`).then(
                            res => {
                                console.log(res)
                                if (res.createPost) {
                                    const newlog = [
                                        ...new Set([...this.state.log, `Posts: ${res.createPost.title}`])
                                    ]
                                    this.setState({ log: newlog })
                                }
                            }))
                }
            })
    }

    async sugestao() {
        console.log('sugestao')

        await this.clientold.request(`
        query{
            allHabilidades{
                cadastro
                name   
            }
        }`).then(
            res => {
                console.log(res)

                if (res.allHabilidades) {
                    res.allHabilidades.map(async i =>
                        await this.clientauth.request(`
                        mutation {
                            createHabilidade(input:{
                                cadastro: ${i.cadastro}
                                name : "${i.name}"
                            }){
                                id
                                name
                            }
                        }`).then(
                            res => {
                                console.log(res)
                                if (res.createHabilidade) {
                                    const newlog = [
                                        ...new Set([...this.state.log, `Habilidade: ${res.createHabilidade.name}`])
                                    ]
                                    this.setState({ log: newlog })
                                }
                            }))
                }
            })
    }

    async news() {
        console.log('news')

        await this.clientold.request(`
        query{
            allNews{
                link
                logo
                name   
            }
        }`).then(
            res => {
                console.log(res)

                if (res.allNews) {
                    res.allNews.map(async i =>
                        await this.clientauth.request(`
                        mutation {
                            createNews(input:{
                                link: "${i.link}"
                                name : "${i.name}"
                                logo: "${i.logo}"
                            }){
                                id
                                name
                            }
                        }`).then(
                            res => {
                                console.log(res)
                                if (res.createNews) {
                                    const newlog = [
                                        ...new Set([...this.state.log, `Noticia: ${res.createNews.name}`])
                                    ]
                                    this.setState({ log: newlog })
                                }
                            }))
                }
            })
    }

    async populate(page) {
        console.log('inciando')

        await this.clientold.request(`
        {
            allUsers(skip: ${page}, first: 500){
                role
                createdAt
                player {
                    name
                    birthday
                    phone
                    status
                    type
                    email
                    description
                    avatar
                    photo {
                        url
                    }
                    phoneverif
                    address {
                        city
                        state
                        street
                        zipcode
                        number
                        complement
                        neighborhood
                        country
                    }
                    notifications {
                        date
                        description
                        link
                        status
                        title
                    }
                    anuncioses {
                        active
                        description
                        files {
                            url
                        }
                        price
                        skills {
                            name
                        }
                    }
                }               
            }
        }`).then(
            res => {
                console.log(res)

                if (res.allUsers) {
                    res.allUsers.map(async i => {
                        const userprimary = i
                        await this.client.request(`
                            mutation{
                                createUser( input:{
                                    role: ${i.role}
                                    createdAt: "${i.createdAt}"
                                    name: "${i.player.name}"
                                    birthday: "${i.player.birthday === null ? null : i.player.birthday}"
                                    phone: "${i.player.phone === null ? null : i.player.phone}"
                                    type: ${i.player.type === null ? null : i.player.type}
                                    status: ${i.player.status}
                                    email: "${i.player.email}"
                                    password: "123"
                                    description: "${i.player.description === null ? null : i.player.description}"
                                    photo: "${i.player.photo ? i.player.photo.url : i.player.avatar}"
                                    phoneverif: ${i.player.phoneverif}
                                    ${i.player.address ?
                                `address: {
                                        city: "${i.player.address.city === null ? null : i.player.address.city}"
                                        state: "${i.player.address.state === null ? null : i.player.address.state}"
                                        street: "${i.player.address.street === null ? null : i.player.address.street}"
                                        zipcode: "${i.player.address.zipcode === null ? null : i.player.address.zipcode}"
                                        number: "${i.player.address.number === null ? null : i.player.address.number}"
                                        complement: "${i.player.address.complement === null ? null : i.player.address.complement}"
                                        neighborhood: "${i.player.address.neighborhood === null ? null : i.player.address.neighborhood}"
                                    }` : ``}
                                }){
                                    id
                                    email
                                    name
                                }
                            }`).then(
                                    async res => {
                                        console.log(res)

                                        if (res.createUser) {
                                            const newlog = [
                                                ...new Set([...this.state.log, `Criar usuario: ${res.createUser.name}`])
                                            ]

                                            this.setState({ log: newlog })

                                            const userId = res.createUser.id

                                            userprimary.player.notifications.map(async n => {
                                                await this.client.request(`
                                                    mutation{
                                                        createNotificationADMIN(
                                                            input: {
                                                                userId: "${userId}"
                                                               createdAt: "${n.date}"
                                                                description: "${n.description}"
                                                                link: "${n.link}"
                                                                status: ${n.status ? true : false}
                                                                title: "${n.title}"
                                                            }
                                                        ){
                                                            title
                                                        }
                                                    }`).then(
                                                    res => {
                                                        console.log(res)

                                                        if (res.createNotificationADMIN) {
                                                            const newlog = [
                                                                ...new Set([...this.state.log, `Notificacao: ${res.createNotificationADMIN.title}`])
                                                            ]
                                                            this.setState({ log: newlog })



                                                        }

                                                    })

                                                userprimary.player.anuncioses.map(async a => {
                                                    await this.client.request(`
                                                                {
                                                                    allSkills(filter: {
                                                                        name: "${a.skills.name}"
                                                                    }){
                                                                        id
                                                                    }
                                                                }
                                                                `).then(async res => {

                                                        if (res.allSkills) {

                                                            let files = []
                                                            await a.files.map(f => files = [
                                                                ...new Set([...files, `"${f.url}"`])
                                                            ])

                                                            await this.client.request(`
                                                                        mutation{
                                                                            createAnuncioADMIN(
                                                                                userId: "${userId}"
                                                                                input: {
                                                                                active: ${a.active}
                                                                                description: "${a.description}"
                                                                                files: [${files}]
                                                                                price: "${a.price}"
                                                                                skillId: "${res.allSkills[0].id}"
                                                                            }){
                                                                                description
                                                                            }
                                                                        }`).then(res => {
                                                                console.log(res)

                                                                if (res.createAnuncioADMIN) {
                                                                    const newlog = [
                                                                        ...new Set([...this.state.log, `Anuncio: ${res.createAnuncioADMIN.description}`])
                                                                    ]
                                                                    this.setState({ log: newlog })
                                                                }
                                                            })
                                                        }
                                                    })
                                                })
                                            })


                                        }
                                    })
                    })
                }
            })
    }

    async propose() {
        console.log('proposta')

        await this.clientold.request(`
        query{
            allProposes{
                date
                dateEnd
                dateEndF
                dateInit
                dateInitF
                description
                from {
                    name
                }
                skill
                status
                timeEnd
                timeEndF
                timeInit
                timeInitF
                to {
                    name
                }
                valueEnd
                valueInit
                aceite
                anuncios {
                    description
                    player {
                        name
                    }
                }
                location
                locationF
            }
        }`).then(
            res => {
                console.log(res)

                if (res.allProposes) {
                    res.allProposes.map(async i => {

                        const propose = i
                        await this.client.request(`
                        {
                            ${i.from ?
                                `from: allUsers(filter:{
                                name: "${i.from.name}"
                            }){
                                id
                            }`: ``}

                            ${i.to ?
                                `to: allUsers(filter: {
                                name: "${i.to.name}"
                            }){
                                id
                            }`: ``}

                            ${i.anuncios ?
                                `anuncio: allAnuncios(filter: {
                                description: "${i.anuncios.description}"
                            }){
                                id
                                user {
                                    name
                                }
                            }`: ``}
                            
                        }`).then(
                                    async res => {
                                        console.log(res)
                                        console.log(propose)
                                        if (res.to) {
                                            await this.client.request(`
                                        mutation {
                                            createProposeADMIN(input: {
                                                createdAt: "${propose.date === null ? null : propose.date}"
                                                dateEnd: "${propose.dateEnd === null ? null : propose.dateEnd}"
                                                dateEndF: "${propose.dateEndF === null ? null : propose.dateEndF}"
                                                dateInit: "${propose.dateInit === null ? null : propose.dateInit}"
                                                dateInitF: "${propose.dateInitF === null ? null : propose.dateInitF}"
                                                description: "${propose.description === null ? null : propose.description}"
                                                fromId: "${res.from.length ? res.from[0].id : ``}"
                                                status: "${propose.status === null ? null : propose.status}"
                                                timeEnd: "${propose.timeEnd === null ? null : propose.timeEnd}"
                                                timeEndF: "${propose.timeEndF === null ? null : propose.timeEndF}"
                                                timeInit: "${propose.timeInit === null ? null : propose.timeInit}"
                                                timeInitF: "${propose.timeInitF === null ? null : propose.timeInitF}"
                                                toId: "${res.to.length ? res.to[0].id : ``}"
                                                valueEnd: "${propose.valueEnd === null ? null : propose.valueEnd}"
                                                valueInit: "${propose.valueInit === null ? null : propose.valueInit}"
                                                aceite: ${propose.aceite}
                                                ${propose.anuncios && res.anuncio.length ?
                                                    `anuncioId: "${propose.anuncios.player.name === res.anuncio[0].user.name ? res.anuncio[0].id : ``}"
                                                `: ``}
                                                location: "${propose.location === null ? null : propose.location}"
                                                locationF: "${propose.locationF === null ? null : propose.locationF}"
                                            }){
                                                description
                                            }
                                        }`).then(
                                                        res => {
                                                            console.log(res)
                                                            if (res.createProposeADMIN) {
                                                                const newlog = [
                                                                    ...new Set([...this.state.log, `proposta: ${res.createProposeADMIN.description}`])
                                                                ]
                                                                this.setState({ log: newlog })
                                                            }
                                                        })
                                        }
                                    })
                    }
                    )
                }
            })
    }

    async chat() {
        console.log('chat')

        await this.clientold.request(`
        query{
            allChats{
                date
                description
                status
                from {
                    name
                }
                to {
                    name
                }
                propose {
                    date
                    description
                }
            }
        }`).then(
            res => {
                console.log(res)

                if (res.allChats) {
                    res.allChats.map(async i => {

                        const chat = i
                        await this.client.request(`
                        {
                            ${i.from ?
                                `from: allUsers(filter:{
                                name: "${i.from.name}"
                            }){
                                id
                            }`: ``}

                            ${i.to ?
                                `to: allUsers(filter: {
                                name: "${i.to.name}"
                            }){
                                id
                            }`: ``}

                            ${i.propose ?
                                `propose: allProposes(filter: {
                                description: "${i.propose.description}"
                                createdAt: "${i.propose.date}"
                            }){
                                id
                            }`: ``}
                            
                        }`).then(
                                    async res => {
                                        console.log(res)
                                        if (res.to) {
                                            await this.client.request(`
                                        mutation {
                                            createChatADMIN(input: {
                                                ${chat.date ?
                                                    `createdAt: "${chat.date}"` : ``}
                                                description: "${chat.description.toString()}"
                                                status: ${chat.status}
                                                fromId: "${res.from.length ? res.from[0].id : ``}"
                                                toId: "${res.to.length ? res.to[0].id : ``}"
                                                proposeId: "${res.propose.length ? res.propose[0].id : ``}"
                                            }){
                                                description
                                            }
                                        }`).then(
                                                        res => {
                                                            console.log(res)
                                                            if (res.createChatADMIN) {
                                                                const newlog = [
                                                                    ...new Set([...this.state.log, `Propose: ${res.createChatADMIN.description}`])
                                                                ]
                                                                this.setState({ log: newlog })
                                                            }
                                                        })
                                        }
                                    })
                    }
                    )
                }
            })
    }

    async comment() {
        console.log('comment')

        await this.clientold.request(`
        query{
            allComments{
                date
                description
                reply
                rating
                typeTo
                from {
                    name
                }
                to {
                    name
                }
                propose {
                    date
                    description
                }
            }
        }`).then(
            res => {
                console.log(res)

                if (res.allComments) {
                    res.allComments.map(async i => {

                        const comment = i
                        await this.client.request(`
                        {
                            ${i.from ?
                                `from: allUsers(filter:{
                                name: "${i.from.name}"
                            }){
                                id
                            }`: ``}

                            ${i.to ?
                                `to: allUsers(filter: {
                                name: "${i.to.name}"
                            }){
                                id
                            }`: ``}

                            ${i.propose ?
                                `propose: allProposes(filter: {
                                description: "${i.propose.description}"
                                createdAt: "${i.propose.date}"
                            }){
                                id
                            }`: ``}
                            
                        }`).then(
                                    async res => {
                                        console.log(res)
                                        if (res.to) {
                                            await this.client.request(`
                                        mutation {
                                            createCommentADMIN(input: {
                                                ${comment.date ?
                                                    `createdAt: "${comment.date}"` : ``}
                                                description: "${comment.description === null ? null : comment.description}"
                                                reply: "${comment.reply === null ? null : comment.reply}"
                                                rating: ${comment.rating}
                                                typeTo: ${comment.typeTo}
                                                fromId: "${res.from.length ? res.from[0].id : ``}"
                                                toId: "${res.to.length ? res.to[0].id : ``}"
                                                proposeId: "${res.propose.length ? res.propose[0].id : ``}"
                                            }){
                                                description
                                            }
                                        }`).then(
                                                        res => {
                                                            console.log(res)
                                                            if (res.createCommentADMIN) {
                                                                const newlog = [
                                                                    ...new Set([...this.state.log, `Coment: ${res.createCommentADMIN.description}`])
                                                                ]
                                                                this.setState({ log: newlog })
                                                            }
                                                        })
                                        }
                                    })
                    }
                    )
                }
            })
    }

    async rank() {
        console.log('rank')

        await this.clientold.request(`
        query{
            allRanks{
                media
                agilidade
                atendimento
                custo
                custoC
                ferramentas
                pontualidade
                pontualidadeC
                respeitoC
                resposta
                solucao
                transparenciaC
                typeTo
                from {
                    name
                }
                player {
                    name
                }
                propose {
                    date
                    description
                }
            }
        }`).then(
            res => {
                console.log(res)

                if (res.allRanks) {
                    res.allRanks.map(async i => {

                        const rank = i
                        await this.client.request(`
                        {
                            ${i.from ?
                                `from: allUsers(filter:{
                                name: "${i.from.name}"
                            }){
                                id
                            }`: ``}

                            ${i.player ?
                                `to: allUsers(filter: {
                                name: "${i.player.name}"
                            }){
                                id
                            }`: ``}

                            ${i.propose ?
                                `propose: allProposes(filter: {
                                description: "${i.propose.description}"
                                createdAt: "${i.propose.date}"
                            }){
                                id
                            }`: ``}
                            
                        }`).then(
                                    async res => {
                                        console.log(res)
                                        if (res.to) {
                                            await this.client.request(`
                                        mutation {
                                            createRankADMIN(input: {
                                                media: ${rank.media}
                                                agilidade: ${rank.agilidade}
                                                atendimento: ${rank.atendimento}
                                                custo: ${rank.custo}
                                                custoC: ${rank.custoC}
                                                ferramentas: ${rank.ferramentas}
                                                pontualidade: ${rank.pontualidade}
                                                pontualidadeC: ${rank.pontualidadeC}
                                                respeitoC: ${rank.respeitoC}
                                                resposta: ${rank.resposta}
                                                solucao: ${rank.solucao}
                                                transparenciaC: ${rank.transparenciaC}
                                                typeTo: ${rank.typeTo}
                                                fromId: "${res.from.length ? res.from[0].id : ``}"
                                                toId: "${res.to.length ? res.to[0].id : ``}"
                                                proposeId: "${res.propose.length ? res.propose[0].id : ``}"
                                            }){
                                                media
                                            }
                                        }`).then(
                                                res => {
                                                    console.log(res)
                                                    if (res.createRankADMIN) {
                                                        const newlog = [
                                                            ...new Set([...this.state.log, `Rank: ${res.createRankADMIN.media}`])
                                                        ]
                                                        this.setState({ log: newlog })
                                                    }
                                                })
                                        }
                                    })
                    }
                    )
                }
            })
    }

    async all() {
        await this.populate(0)
        await this.populate(500)
        await this.populate(1000)
        await this.populate(1500)
        await this.populate(2000)
        await this.populate(2500)
        await this.populate(3000)
        await this.populate(3500)
        await this.populate(4000)
        await this.populate(4500)
        await this.populate(5000)
        await this.populate(5500)
        await this.populate(6000)
        await this.populate(6500)
        await this.populate(7000)
        await this.propose()
        await this.chat()
        await this.comment()
        await this.rank()
    }

    render() {
        return (
            <Fragment>
                <div className="blogPost">
                    <p><button onClick={() => this.all(0)}>Metendo o loco</button></p>
                    <p><button onClick={() => this.populate(0)}>Usuarios 1</button></p>
                    <p><button onClick={() => this.populate(500)}>Usuarios 2</button></p>
                    <p><button onClick={() => this.populate(1000)}>Usuarios 3</button></p>
                    <p><button onClick={() => this.populate(1500)}>Usuarios 4</button></p>
                    <p><button onClick={() => this.populate(2000)}>Usuarios 5</button></p>
                    <p><button onClick={() => this.populate(2500)}>Usuarios 6</button></p>
                    <p><button onClick={() => this.populate(3000)}>Usuarios 7</button></p>
                    <p><button onClick={() => this.populate(3500)}>Usuarios 8</button></p>
                    <p><button onClick={() => this.populate(4000)}>Usuarios 1</button></p>
                    <p><button onClick={() => this.populate(4500)}>Usuarios 2</button></p>
                    <p><button onClick={() => this.populate(5000)}>Usuarios 3</button></p>
                    <p><button onClick={() => this.populate(5500)}>Usuarios 4</button></p>
                    <p><button onClick={() => this.populate(6000)}>Usuarios 5</button></p>
                    <p><button onClick={() => this.populate(6500)}>Usuarios 6</button></p>
                    <p><button onClick={() => this.populate(7000)}>Usuarios 7</button></p>
                    <p><button onClick={() => this.categories()}>Categorias</button></p>
                    <p><button onClick={() => this.habilidades()}>Habilidades</button></p>
                    <p><button onClick={() => this.posts()}>Posts</button></p>
                    <p><button onClick={() => this.sugestao()}>Sugestao Habilidade</button></p>
                    <p><button onClick={() => this.news()}>Noticias</button></p>
                    <p><button onClick={() => this.propose()}>Propostas</button></p>
                    <p><button onClick={() => this.chat()}>Chat</button></p>
                    <p><button onClick={() => this.comment()}>Comment</button></p>
                    <p><button onClick={() => this.rank()}>Rank</button></p>
                    {this.state.log.map(i => <p key={i}>{i}</p>)}
                </div>
            </Fragment >
        )
    }
}

